import React from 'react';

import PropTypes from 'prop-types';
import InfoCircleIcon from 'react-icons/lib/fa/info-circle';

import {
    Control,
    SplitTest,
    Variant,
} from 'wanderu-component-split-test';
import {
    DropdownMenu,
    TooltipController,
    TooltipSelect,
    Typography,
    WDSButton,
} from 'wanderu-components';
import { RECOMMENDED } from 'wanderu-ducks-search';
import { localize } from 'wanderu-i18n';

import SortOptions from '../SortOptions/SortOptions';
import { LocationPin } from './LocationPin';
import events from './events/SearchListHeaderEvents';

import styles from './SearchListHeader.scss';

function SearchListHeader(props) {
    const {
        t,
        activeSortType,
        numberOfTripsToShow,
        totalTrips,
        onSort,
        sortOptions,
        onMapClick,
        showMap = false,
    } = props;

    const _onHover = () => {
        events.sortInfoHovered();
    };

    return (
        <div className={styles.header}>
            <div className={styles.leftColumn}>
                <div className={styles.dropdownContainer}>
                    <DropdownMenu
                        altText={'Sort'}
                        className={styles.dropdown}
                        title={(
                            <span className={styles.sortTitle}>
                                {t('sort-by', {
                                    sortType: t(`${activeSortType}_tag`),
                                })}
                                {activeSortType === RECOMMENDED && (
                                    <TooltipController
                                        offsetX="center"
                                        offsetY={10}
                                        onHover={_onHover}
                                    >
                                        <div className={styles.tooltip}>
                                            {t('recommended-tooltip')}
                                        </div>
                                        <TooltipSelect>
                                            <InfoCircleIcon
                                                alt={t('more-info')}
                                                className={styles.info}
                                                style={{ verticalAlign: '-3px' }}
                                                title={t('click-for-more')}
                                            />
                                        </TooltipSelect>
                                    </TooltipController>
                                )}
                            </span>
                        )}
                    >
                        <SortOptions
                            activeSortType={activeSortType}
                            onSort={onSort}
                            sortOptions={sortOptions}
                        />
                    </DropdownMenu>
                </div>
                <SplitTest testName="stationMap">
                    <Control />
                    <Variant name="showMap">
                        {totalTrips
                            ? <WDSButton className={styles.mapButton} onClick={onMapClick} variant="unstyled">
                                <LocationPin />
                                <Typography className={styles.mapText} variant="h6">
                                    {showMap
                                        ? 'Hide map'
                                        : 'Show map'}
                                </Typography>
                            </WDSButton>
                            : ''
                        }
                    </Variant>
                </SplitTest>
            </div>
            <div>
                {t('showing-trips', {
                    numberToShow: (
                        <span
                            className={styles.number}
                            key="numberToShow"
                        >
                            {numberOfTripsToShow}
                        </span>
                    ),
                    total: (
                        <span
                            className={styles.number}
                            key="totalTrips"
                        >
                            {totalTrips}
                        </span>
                    ),
                })}
            </div>
        </div>
    );
}

SearchListHeader.propTypes = {
    totalTrips: PropTypes.number,
    numberOfTripsToShow: PropTypes.number,
    showReset: PropTypes.bool,
    onResetAllFilters: PropTypes.func,
    onSort: PropTypes.func,
    activeSortType: PropTypes.string,
    sortOptions: PropTypes.object,
};

SearchListHeader.defaultProps = {
    totalTrips: 0,
    numberOfTripsToShow: 0,
    showReset: false,
    onResetAllFilters() {},
    onSort() {},
    activeSortType: '',
    sortOptions: {},
};

export { SearchListHeader };
export default localize(SearchListHeader, 'baseApp');
